import { render } from "./AdminMaterials.vue?vue&type=template&id=58a76700"
import script from "./AdminMaterials.vue?vue&type=script&lang=js"
export * from "./AdminMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__